module.exports = __webpack_public_path__ + "653e1ed26371b7e859e2a2a775354f67.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/icon-video-black.svg
// module id = 1006
// module chunks = 69